import { AuthorizeNetAccount } from '../admin/store';

export class AuthorizeNetAccountViewModel {
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public storeId: number = 0;
}

export class AuthorizeNetAccountListViewModel extends AuthorizeNetAccountViewModel {
    public accounts: AuthorizeNetAccount[] = [];
}

export class AuthorizeNetAccountAddOrUpdateViewModel extends AuthorizeNetAccountViewModel {
    public account: AuthorizeNetAccount = {};
    public id: string = '';
}
